export const projectData=[
    {
        "name":"Communication Buddy",
        "link":"https://github.com/devanshukd04/Communication-Buddy",
        "description":"Communication Buddy is a project developed using Deep learning which helps users to improve his/her communication skills",
        "image":"images/project1.png"
    },
    {
        "name":"Sign Language Detection",
        "link":"https://github.com/devanshukd04/Sign-Language-Detection",
        "description":"Sign Language Detection project is developed using Deep learning, it classifies 26 static signs and 5 dynamic signs to help deaf and dumb people in communicating",
        "image":"images/project2.png"
    },
    {
        "name":"Face Mask Detection",
        "link":"https://github.com/devanshukd04/Face-mask-Detection",
        "description":"Face Mask Detection project is developed using Deep Learning. This project is able to classify mask and unmask images",
        "image":"images/project3.jpg"
    },
    {
        "name":"Multiprogramming Operating System",
        "link":"https://github.com/devanshukd04/Operating-System-Course-Project",
        "description":"Multiperforming Operating System is developed, this project is able to perform various operations on given input",
        "image":"images/project4.png"
    },
    {
        "name":"Blogging Website",
        "link":"https://github.com/The-Invaders-7/dbmsCP",
        "description":"Blogging Website project  is developed using MERN stack. This projeect is able to provide function to create, update, delete and like post",
        "image":"images/project5.png"
    },
    {
        "name":"Inter-College Buddy",
        "link":"https://github.com/devanshukd04/Inter-Buddy",
        "description":"This project is developed using MERN stack. This project helps student get interview Experiences from their seniors, where they read this interview experiences and prepare in the right direction",
        "image":"images/project6.png"
    },
    {
        "name":"Slack Shield",
        "link":"https://github.com/The-Invaders-7/EDI-III-Slack-Shield",
        "description":"Slack Shield project is able to locate slack spaces in OS, extract data from slack space and predict whether it is malicious or non-malicious",
        "image":"images/project7.png"
    },
    {
        "name":"Sudoku Solver",
        "link":"https://github.com/The-Invaders-7/DS_CP-Sudoku-Solver",
        "description":"Sudoku Solver is developed in Java. Sudoku Solver helps people stuck in solving Sudoku by giving hints based on the current input in Sudoku",
        "image":"images/project8.png"
    },
    {
        "name":"Encoding Techniques",
        "link":"https://github.com/The-Invaders-7/DAA-CP-Encoding-Techniques-",
        "description":"Encoding Technique is a project developed in Java.",
        "image":"images/project9.png"
    },
    {
        "name":"VIT Bot",
        "link":"https://github.com/The-Invaders-7/VIT-BOT",
        "description":"VIT Bot is a chatbot developed for VIT college. It resolves students query related to various topics regarding college details, club activities and many more.",
        "image":"images/project10.png"
    }
];